module.exports = __webpack_public_path__ + "static/scale-model-of-garman-sculpture-works-in-fort-lauderdale-florida-ca9a959d3481171351836d0b20a60d1a.png";